// 数组转树结构
export function arrayToTree(list: object[], callback: any = () => {}, props = { id: 'id', pid: 'pid', children: 'children' }) {
  const tree: object[] = [];
  const map: any = {};

  // list = cloneObj(list);

  const listLength = list.length;
  for (let i = 0; i < listLength; i++) {
    const node: any = list[i];
    const nodeId: any = node[props.id];
    map[nodeId] = node;
    callback(node);
  }

  for (let i = 0; i < listLength; i++) {
    const node: any = list[i];
    const nodePid: any = node[props.pid];
    const parentNode: any = map[nodePid];
    if (parentNode) {
      parentNode[props.children] = parentNode[props.children] || [];
      parentNode[props.children].push(node);
    } else {
      tree.push(node);
    }
  }

  return tree;
}

// 深度拷贝数组/对象
declare let window: Window & { JSON: any };

export function cloneObj(obj: any) {
  let str,
    newobj: any = obj.constructor === Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  } else if (window.JSON) {
    (str = JSON.stringify(obj)), //系列化对象
      (newobj = JSON.parse(str)); //还原
  } else {
    for (const i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
    }
  }
  return newobj;
}

//获取所有子孙节点 arr为list结构
export function sonsTree(arr: any[], id: string): any[] {
  const temp: any[] = [],
    lev = 0;
  const forFn = function(arr: any[], id: string, lev: number) {
    for (let i = 0; i < arr.length; i++) {
      const item: any = arr[i];
      if (item.pid == id) {
        item.lev = lev;
        temp.push(item);
        forFn(arr, item.id, lev + 1);
      }
    }
  };
  forFn(arr, id, lev);
  return temp;
}
